import {
  CUSTOM_DECLARED_INCOME,
  CUSTOM_DOCUMENTATION_REQUIRED_RESPONSES,
  CUSTOM_GET_SIGNATURE_URL_BY_LOAN_ID,
} from "./fakeResponsesCustomPayloads";

export const fakeGetResponsesByActionTypeDictionary = {
  // REQUEST_GET_OPTIN_BY_LOAN_ID_AND_BORROWER_ID: {
  //   onFulfilled: {
  //     payload: fakeOptins,
  //     type: "REQUEST_GET_OPTIN_BY_LOAN_ID_AND_BORROWER_ID_FULFILLED",
  //   },
  //   onRejected: {
  //     payload: fakeOptins,
  //     type: "REQUEST_GET_OPTIN_BY_LOAN_ID_AND_BORROWER_ID_FULFILLED",
  //   },
  // },
  // REQUEST_GET_LOAN_BEFORE_AGENT_SEQUENCE: {
  //   onFulfilled: {
  //     payload: CUSTOM_LOAN_BEFORE_AGENT_SEQUENCE
  //     type: "REQUEST_GET_LOAN_BEFORE_AGENT_SEQUENCE_FULFILLED",
  //   },
  // },
  REQUEST_GET_SIGNATURE_URL_BY_LOAN_ID: {
    onRejected: {
      payload: CUSTOM_GET_SIGNATURE_URL_BY_LOAN_ID,
      type: "REQUEST_GET_SIGNATURE_URL_BY_LOAN_ID_FULFILLED",
    },
  },
  REQUEST_GET_DOCUMENTATION_REQUIRED: {
    onFulfilled: {
      payload: CUSTOM_DOCUMENTATION_REQUIRED_RESPONSES.UNCOMPLETED,
      type: "REQUEST_GET_DOCUMENTATION_REQUIRED_FULFILLED",
    },
  },
  REQUEST_GET_DECLARED_INCOME: {
    onFulfilled: {
      payload: CUSTOM_DECLARED_INCOME,
      type: "REQUEST_GET_DECLARED_INCOME_FULFILLED",
    },
    onRejected: {
      payload: CUSTOM_DECLARED_INCOME,
      type: "REQUEST_GET_DECLARED_INCOME_FULFILLED",
    },
  },
};
